module.exports = __webpack_public_path__ + "img/right-align.4abb337f.svg";